import { milisecondsToHHMM } from '@apps/main/modules/helpers/formatting';

import { assertValue } from '@libs/utils';

export function timeRangeMsToHHMM(value: number[]): string {
  const from = value[0];
  const to = value[1];
  assertValue(
    from,
    `TimeRangeFormatters.helper.ts > timeRangeMsToHHMM > from > ${value[0]}`
  );
  assertValue(
    to,
    `TimeRangeFormatters.helper.ts > timeRangeMsToHHMM > from > ${value[1]}`
  );
  return `${milisecondsToHHMM(from)} - ${milisecondsToHHMM(to)}`;
}
